import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const ContainerR = styled.div`
  align-self: center;
  box-sizing: border-box;
  margin: 20px 0;
  width: 100%;
`;

export const TextFooter = styled.h2`
  text-align: center;
  font-weight: 500;
  color: ${Variables.colorOrange};
`;

export const ContainerImage = styled.div`
  width: 200px;
  height: 200px;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
